import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GenericOperationalEventStatus, OperationalEventsState } from "./operationalEventsTypes";
import { GridSortModel, GridFilterModel } from "@mui/x-data-grid-premium";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useEffect, useMemo } from "react";
import { operationalEventApi } from "../../app/apislices/operationalEventApi";

const initialState: OperationalEventsState = {
  selectedMeasuringPoint: "",
  combinedStatusList: [],
  measuringPointsSortModel: [
    { field: "substation", sort: "asc" },
    { field: "switchgear", sort: "asc" },
  ],
  measuringPointsFilterModel: { items: [] },
  eventsSortModel: [
    { field: "type", sort: "asc" },
    { field: "start", sort: "desc" },
  ],
  eventsFilterModel: { items: [] },
};

const operationalEventsSlice = createSlice({
  name: "operationalEventsSlice",
  initialState,
  reducers: {
    setSelectedMeasuringPoint: (state, action: PayloadAction<string>) => {
      state.selectedMeasuringPoint = action.payload;
    },
    setCombinedStatusList: (state, action: PayloadAction<GenericOperationalEventStatus[]>) => {
      state.combinedStatusList = action.payload;
    },
    setMeasuringPointsSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.measuringPointsSortModel = action.payload;
    },
    setMeasuringPointsFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.measuringPointsFilterModel = action.payload;
    },
    setEventsSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.eventsSortModel = action.payload;
    },
    setEventsFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.eventsFilterModel = action.payload;
    },
  },
});

export const {
  setSelectedMeasuringPoint,
  setCombinedStatusList,
  setMeasuringPointsSortModel,
  setMeasuringPointsFilterModel,
  setEventsSortModel,
  setEventsFilterModel,
} = operationalEventsSlice.actions;

export default operationalEventsSlice.reducer;
